import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import NotFoundView from '../views/NotFoundView.vue';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'home',
            component: HomeView
        },
        {
            path: '/staff-lists',
            name: 'stafflists',
            component: () => import('../views/StaffListsView.vue')
        },
        {
            path: '/staff-lists/:id',
            name: 'stafflists-id',
            component: () => import('../views/StaffListsView.vue')
        },
        {
            path: '/guidelines',
            name: 'guidelines',
            component: () => import('../views/GuidelinesView.vue')
        },
        {
            path: '/faq',
            name: 'faq',
            component: () => import('../views/FaqView.vue')
        },
        {
            path: '/our-staff',
            name: 'our-staff',
            component: () => import('../views/OurStaffView.vue')
        },
        {
            path: '/scraping',
            name: 'scraping',
            component: () => import('../views/ScrapingView.vue')
        },
        {
            path: '/tos',
            name: 'tos',
            component: () => import('../views/TosView.vue')
        },
        {
            path: '/stats',
            name: 'stats',
            component: () => import('../views/StatsView.vue')
        },
        {
            path: '/staff',
            name: 'staff',
            component: () => import('../views/StaffView.vue')
        },
        {
            path: '/staff/create/:step',
            name: 'staff-create-step',
            component: () => import('../views/StaffView.vue')
        },
        {
            path: '/staff/:id',
            name: 'staff-id',
            component: () => import('../views/StaffView.vue')
        },
        {
            path: '/person/:id',
            name: 'person-page',
            component: () => import('../views/PersonView.vue')
        },
        {
            path: '/studio/:id',
            name: 'studio-page',
            component: () => import('../views/PersonView.vue')
        },
        {
            path: '/readings',
            name: 'readings',
            component: () => import('../views/ReadingsView.vue')
        },
        {
            path: '/roles',
            name: 'roles',
            component: () => import('../views/RolesView.vue')
        },
        {
            path: '/compare',
            name: 'compare',
            component: () => import('../views/CompareView.vue')
        },
        {
            path: '/cross-credit',
            name: 'cross-credit',
            component: () => import('../views/CrossCreditView.vue')
        },
        {
            path: '/challenge',
            name: 'challenge',
            component: () => import('../views/ChallengeView.vue')
        },
        {
            path: '/challenge/:step',
            name: 'challenge-step',
            component: () => import('../views/ChallengeView.vue')
        },
        {
            path: '/account',
            name: 'settings',
            component: () => import('../views/AccountView.vue')
        },
        {
            path: '/history',
            name: 'history',
            component: () => import('../views/HistoryView.vue')
        },
        {
            path: '/reports',
            name: 'reports',
            component: () => import('../views/ReportsView.vue')
        },
        {
            path: '/report/:id/:password?',
            name: 'report',
            component: () => import('../views/ReportView.vue')
        },
        {
            path: '/search',
            name: 'search',
            component: () => import('../views/SearchView.vue')
        },
        {
            path: '/compare',
            name: 'compare',
            component: () => import('../views/CompareView.vue')
        },
        {
            path: '/admin',
            name: 'admin',
            component: () => import('../views/AdminView.vue')
        },
        {
            path: '/user/:id',
            name: 'user',
            component: () => import('../views/UserView.vue')
        },
        // {
        //     path: '/test',
        //     name: 'test',
        //     component: () => import('../views/TestView.vue')
        // },
        {
            path: '/:pathMatch(.*)*',
            component: NotFoundView
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { el: to.hash };
        }

        return { top: 0 };
    }
});

export default router;